window.mainProductFunc = function(){
  const thumbnailSwiper = new Swiper('.thumbnail-swiper', {
    spaceBetween: 12,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const mainSwiper = new Swiper('.main-swiper', {
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbnailSwiper,
    },
  });

  document.querySelectorAll('.ed-main-product').forEach(function(productSection) {
    const productJsonElement = productSection.querySelector('[data-product-json]');
    if (!productJsonElement) return;

    const productData = JSON.parse(productJsonElement.textContent);
    const variantRadios = productSection.querySelectorAll('.variant-radio');
    const priceContainer = productSection.querySelector('.price-container');
    const addToCartBtn = productSection.querySelector('.add-to-cart');
    const buyNowBtn = productSection.querySelector('.buy-now');
    const variantIdInput = productSection.querySelector('.variant-id');
    const quantityInput = productSection.querySelector('.quantity-input');
    const quantityMinus = productSection.querySelector('.quantity-minus');
    const quantityPlus = productSection.querySelector('.quantity-plus');
    const chooseCards = productSection.querySelectorAll('.choose-card');
    const coupleItems = productSection.querySelectorAll('.couple-item');
    const mainSwiperInstance = mainSwiper;
    const priceSavingsContainer = productSection.querySelector('.price-savings-container');
    const totalPriceElement = priceSavingsContainer ? priceSavingsContainer.querySelector('.total-price') : null;

    const cartCountElements = productSection.querySelectorAll('.dynamic-cart-count');
    if (cartCountElements.length > 0) {
      cartCountElements.forEach(element => {
        const productId = element.dataset.productId;
        const timestamp = priceSavingsContainer ? parseInt(priceSavingsContainer.dataset.timestamp) : 0;
        const fiveHours = 5 * 60 * 60 * 1000;
        const currentTime = new Date().getTime();
        const lastUpdate = Math.floor(timestamp / fiveHours) * fiveHours;
        const nextUpdate = lastUpdate + fiveHours;

        function updateCartCount() {
          if (currentTime >= nextUpdate) {
            const initialCount = parseInt(element.querySelector('.cart-count').textContent);
            element.querySelector('.cart-count').textContent = initialCount;
            if (priceSavingsContainer) {
              priceSavingsContainer.dataset.timestamp = Math.floor(currentTime / 1000);
            }
          }
        }

        updateCartCount();
        setInterval(updateCartCount, 60000);
      });
    }

    function convertVariantId(selectedVariantId) {
      return parseInt(selectedVariantId, 10);
    }

    function findSelectedVariant(variantId) {
      return productData.variants.find(v => v.id === variantId);
    }

    function updatePrice(selectedVariant) {
      if (priceContainer) {
        priceContainer.innerHTML = '';
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          priceContainer.innerHTML += `<span class="price-regular">${Shopify.formatMoney(selectedVariant.price)}</span>`;
          priceContainer.innerHTML += `<span class="price-compare strikethrough">${Shopify.formatMoney(selectedVariant.compare_at_price)}</span>`;
          priceContainer.innerHTML += `<span class="discount-badge">${Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price)} OFF</span>`;
        } else {
          priceContainer.innerHTML += `<span class="price-regular">${Shopify.formatMoney(selectedVariant.price)}</span>`;
        }
        if (productData.tags && productData.tags.length > 0) {
          priceContainer.innerHTML += `<span class="product-first-tag">${productData.tags[0]}</span>`;
        }
      }
    }

    function updateVariantInput(selectedVariant) {
      if (variantIdInput) {
        variantIdInput.value = selectedVariant.id;
      }
    }

    function updatePriceDisplay(selectedVariant) {
      if (totalPriceElement) {
        const originalPriceElement = totalPriceElement.querySelector('.original-price');
        const comparePriceElement = totalPriceElement.querySelector('.compare-price');
        const savedAmountElement = totalPriceElement.querySelector('.saved-amount');
        const paymentPlanElement = totalPriceElement.querySelector('.payment-plan');

        originalPriceElement.textContent = Shopify.formatMoney(selectedVariant.price);
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          comparePriceElement.textContent = Shopify.formatMoney(selectedVariant.compare_at_price);
          comparePriceElement.style.display = 'inline';
          savedAmountElement.textContent = `You saved ${Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price)}!`;
          savedAmountElement.style.display = 'block';
          paymentPlanElement.style.display = 'block';
          paymentPlanElement.textContent = `4 Payments of ${Shopify.formatMoney(selectedVariant.price / 4.0)} With Klarna`;
        } else {
          //comparePriceElement.style.display = 'none';
          //savedAmountElement.style.display = 'none';
         //paymentPlanElement.style.display = 'none';
        }
      }
    }

    function calculateTotalPrice() {
      if (totalPriceElement) {
        const baseVariantId = parseInt(variantIdInput.value);
        const baseVariant = findSelectedVariant(baseVariantId);
        let totalPrice = baseVariant ? baseVariant.price : 0;

        chooseCards.forEach(card => {
          if (card.classList.contains('selected')) {
            const choosePrice = parseFloat(card.dataset.choosePrice) || 0;
            totalPrice += choosePrice;
          }
        });

        coupleItems.forEach(item => {
          if (item.classList.contains('selected')) {
            const couplePriceElement = item.querySelector('.couple__item-price');
            const couplePrice = couplePriceElement ? parseFloat(couplePriceElement.dataset.couplePrice) || 0 : 0;
            totalPrice += couplePrice;
          }
        });

        const originalPriceElement = totalPriceElement.querySelector('.original-price');
        originalPriceElement.textContent = Shopify.formatMoney(totalPrice);
      }
    }

    function updateProductDetails(selectedVariantId) {
      const numericVariantId = convertVariantId(selectedVariantId);
      const selectedVariant = findSelectedVariant(numericVariantId);
      if (!selectedVariant) return;

      updatePrice(selectedVariant);
      updateVariantInput(selectedVariant);
      updateButtons(selectedVariant);
      slideToVariantImage(selectedVariant);
      updateUrl(selectedVariantId.toString());
      updatePriceDisplay(selectedVariant);
      calculateTotalPrice();
    }

    function initializeFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      if (urlVariantId) {
        const numericUrlVariantId = convertVariantId(urlVariantId);
        const urlVariant = findSelectedVariant(numericUrlVariantId);
        if (urlVariant) {
          variantRadios.forEach(radio => {
            if (parseInt(radio.dataset.variantId) === numericUrlVariantId) {
              radio.checked = true;
            }
          });
          updateProductDetails(urlVariantId);
        }
      }
    }

    function updateQuantity(direction) {
      if (quantityInput) {
        let currentQuantity = parseInt(quantityInput.value, 10);
        if (direction === 'minus' && currentQuantity > 1) {
          quantityInput.value = currentQuantity - 1;
        } else if (direction === 'plus') {
          quantityInput.value = currentQuantity + 1;
        }
      }
    }

    function updateButtons(selectedVariant) {
      if (addToCartBtn && buyNowBtn) {
        const isAvailable = selectedVariant.available;
        addToCartBtn.disabled = !isAvailable;
        buyNowBtn.disabled = !isAvailable;
      //  addToCartBtn.textContent = isAvailable ? 'Add to Cart' : 'Out of Stock';
        buyNowBtn.textContent = isAvailable ? 'Buy Now' : 'Out of Stock';
      }
    }

    function slideToVariantImage(selectedVariant) {
      if (mainSwiperInstance) {
        const slides = productSection.querySelectorAll('.swiper-slide');
        const selectedMediaId = selectedVariant.featured_media.id;
        if (selectedMediaId) {
          const matchingSlide = Array.from(slides).find(slide => parseInt(slide.dataset.mediaId) === selectedMediaId);
          if (matchingSlide) {
            const slideIndex = Array.from(slides).indexOf(matchingSlide);
            mainSwiperInstance.slideTo(slideIndex);
          }
        }
      }
    }

    function updateUrl(selectedVariantId) {
      const url = new URL(window.location);
      if (!productSection.closest('.quick-view-modal')) {
        url.searchParams.set('variant', selectedVariantId);
        window.history.pushState({}, '', url);
      }
    }

    function addToCart() {
      if (addToCartBtn && !addToCartBtn.disabled) {
        const formData = new FormData();
        formData.append('id', variantIdInput.value);
        formData.append('quantity', quantityInput ? quantityInput.value : 1);
        const selectedVariants = [
          { id: variantIdInput.value, quantity: quantityInput ? quantityInput.value : 1 }
        ];
        if (chooseCards.length > 0) {
          chooseCards.forEach(card => {
            if (card.classList.contains('selected')) {
              const variantId = card.dataset.choose;
              selectedVariants.push({ id: variantId, quantity: 1 });
            }
          });
        }
        if (coupleItems.length > 0) {
          coupleItems.forEach(item => {
            if (item.classList.contains('selected')) {
              const variantId = item.dataset.couple;
              selectedVariants.push({ id: variantId, quantity: 1 });
            }
          });
        }

        selectedVariants.reduce((promise, variant) => {
          return promise.then(() => {
            const itemFormData = new FormData();
            itemFormData.append('id', variant.id);
            itemFormData.append('quantity', variant.quantity);
            return fetch('/cart/add.js', {
              method: 'POST',
              body: itemFormData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
              console.log(`Added to cart: ${variant.id}`, data);
            })
            .catch(error => {
              console.error(`Error adding variant ${variant.id} to cart:`, error);
              throw error;
            });
          });
        }, Promise.resolve())
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Cart addition process failed:', error);
        });
      }
    }

    function buyNow() {
      if (buyNowBtn && !buyNowBtn.disabled) {
        const formData = new FormData();
        formData.append('id', variantIdInput.value);
        formData.append('quantity', quantityInput ? quantityInput.value : 1);
        const selectedVariants = [
          { id: variantIdInput.value, quantity: quantityInput ? quantityInput.value : 1 }
        ];
        if (chooseCards.length > 0) {
          chooseCards.forEach(card => {
            if (card.classList.contains('selected')) {
              const variantId = card.dataset.choose;
              selectedVariants.push({ id: variantId, quantity: 1 });
            }
          });
        }
        if (coupleItems.length > 0) {
          coupleItems.forEach(item => {
            if (item.classList.contains('selected')) {
              const variantId = item.dataset.couple;
              selectedVariants.push({ id: variantId, quantity: 1 });
            }
          });
        }

        selectedVariants.reduce((promise, variant) => {
          return promise.then(() => {
            const itemFormData = new FormData();
            itemFormData.append('id', variant.id);
            itemFormData.append('quantity', variant.quantity);
            return fetch('/cart/add.js', {
              method: 'POST',
              body: itemFormData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
              console.log(`Added to cart: ${variant.id}`, data);
            })
            .catch(error => {
              console.error(`Error adding variant ${variant.id} to cart:`, error);
              throw error;
            });
          });
        }, Promise.resolve())
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Cart addition process failed:', error);
        });
      }
    }

    chooseCards.forEach(function(card) {
      if (!card.classList.contains('disabled')) {
        card.addEventListener('click', function() {
          card.classList.toggle('selected');
          calculateTotalPrice();
        });
      }
    });

    coupleItems.forEach(function(item) {
      if (!item.classList.contains('disabled')) {
        item.addEventListener('click', function() {
          item.classList.toggle('selected');
          calculateTotalPrice();
        });
      }
    });

    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function(event) {
        const selectedVariantId = radio.dataset.variantId;
        updateProductDetails(selectedVariantId);
        const variantOption = event.target.closest('.variant-option');
        if (variantOption && event.target.type === 'radio') {
          const optionSelectedValue = variantOption.querySelector('.option-selected-value');
          if (optionSelectedValue) {
            optionSelectedValue.textContent = event.target.value;
          }
        }
      });
    });

    if (quantityMinus && quantityPlus && quantityInput) {
      quantityMinus.addEventListener('click', function() {
        updateQuantity('minus');
      });
      quantityPlus.addEventListener('click', function() {
        updateQuantity('plus');
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(event) {
        event.preventDefault();
        addToCart();
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(event) {
        event.preventDefault();
        buyNow();
      });
    }

    function otherSellersSwiper() {
      const otherSellerProducts = productSection.querySelector('.other-seller-products');
      if (!otherSellerProducts) return;

      const swiperEl = otherSellerProducts.querySelector('.swiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        slidesPerView: 2.1,
        spaceBetween: 16,
        a11y: false,
        loop: true,
        speed: 400,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 2.8,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    }

    function initAnimatedTabs() {
      const tabButtons = productSection.querySelectorAll('.tab-btn');
      const tabContents = productSection.querySelectorAll('.tab-content');

      if (!tabButtons.length || !tabContents.length) return;

      tabButtons.forEach((btn, index) => {
        btn.addEventListener('click', function() {
          tabButtons.forEach(button => button.classList.remove('active'));
          tabContents.forEach(content => content.classList.remove('active'));
          this.classList.add('active');
          if (tabContents[index]) {
            tabContents[index].classList.add('active');
          }
        });
      });
    }


    function initAccordion() {
      const accordionWrappers = productSection.querySelectorAll('.accordion-wrapper');

      accordionWrappers.forEach(wrapper => {
        const accordions = wrapper.querySelectorAll('.accordion-item');

        function openAccordion(accordion) {
          const content = accordion.querySelector('.accordion__content');
          accordion.classList.add('accordion__active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }

        function closeAccordion(accordion) {
          const content = accordion.querySelector('.accordion__content');
          accordion.classList.remove('accordion__active');
          content.style.maxHeight = null;
        }

        accordions.forEach(accordion => {
          const intro = accordion.querySelector('.accordion__intro');
          const content = accordion.querySelector('.accordion__content');

          intro.addEventListener('click', () => {
            if (content.style.maxHeight) {
              closeAccordion(accordion);
            } else {
              accordions.forEach(a => closeAccordion(a));
              openAccordion(accordion);
            }
          });
        });
      });
    }


    function initFaq() {
      const faqWrappers = productSection.querySelectorAll('.faq-wrapper');

      faqWrappers.forEach(wrapper => {
        const faqs = wrapper.querySelectorAll('.faq-item');

        if (faqs.length > 0) {
          openFaq(faqs[0]);
        }

        function openFaq(faq) {
          const content = faq.querySelector('.faq__content');
          faq.classList.add('faq__active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }

        function closeFaq(faq) {
          const content = faq.querySelector('.faq__content');
          faq.classList.remove('faq__active');
          content.style.maxHeight = null;
        }

        faqs.forEach(faq => {
          const intro = faq.querySelector('.faq__intro');
          const content = faq.querySelector('.faq__content');

          intro.addEventListener('click', () => {
            if (content.style.maxHeight) {
              closeFaq(faq);
            } else {
              faqs.forEach(f => closeFaq(f));
              openFaq(faq);
            }
          });
        });
      });
    }



    initFaq();

    initAccordion();

    initAnimatedTabs();

    otherSellersSwiper();

    initializeFromUrl();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  window.mainProductFunc();
});